import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  getQuestionPaperTopics,
  getQuestionPapers,
  createTest,
  fetchBulkQuestions
} from './api'
import { InitialState, GetQuestionPapersResponse } from './types'

const initialState: InitialState = {
  isLoading: false,
  questionPaperTopics: [],
  questionBank: []
}

export const createTestSlice = createSlice({
  name: 'createTest',
  initialState,
  reducers: {
    resetQuestionPaperTopics: (state) => {
      state.questionPaperTopics = []
    }
  },
  extraReducers: {
    [getQuestionPaperTopics.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getQuestionPaperTopics.fulfilled.toString()]: (
      state,
      action: PayloadAction<Array<string>>
    ) => {
      state.isLoading = false
      state.questionPaperTopics = action?.payload
    },
    [fetchBulkQuestions.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [fetchBulkQuestions.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [fetchBulkQuestions.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getQuestionPaperTopics.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [createTest.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [createTest.fulfilled.toString()]: (state) => {
      state.isLoading = false
    },
    [createTest.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getQuestionPapers.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getQuestionPapers.rejected.toString()]: (state) => {
      state.isLoading = false
    },
    [getQuestionPapers.fulfilled.toString()]: (
      state,
      action: PayloadAction<GetQuestionPapersResponse>
    ) => {
      state.isLoading = false
      state.questionBank = action?.payload?.questionBank
      state.pageSize = action?.payload?.pageSize
      state.currentPage = action?.payload?.currentPage
    }
  }
})

export default createTestSlice.reducer
